import React, {Component} from 'react'
import PropTypes from 'prop-types'
import timeHumanize from "../../helpers/timeHumanize"
import getLocationType from "../../../vietnameses/getLocationType"
import classNames from 'classnames'
import ButtonRemoveItem from "./ButtonRemoveItem"
import { Checkbox, Tag } from 'antd'


class RowBoxItem extends Component {
    _handleChange = (itemFba) => {
        const {onSelected} = this.props
        const isCheckedFba = this._detectChecked()

        if (typeof onSelected === 'function') {
            onSelected(itemFba, !isCheckedFba)
        }
    }

    _detectChecked = () => {
        const {item: itemFba, arrSelected} = this.props

        return arrSelected.some(iFba => iFba.id === itemFba._id)
    }

    render() {
        const {item: itemFba, index, onRefresh, box, showDelete, onCheckAll, incompleteMap} = this.props
        const {item_number, item_index, product, created, labelDetails, location_type} = itemFba
        const {size, type} = product
        const {partnerTrackingNumber} = Object.assign({}, labelDetails)
        const isCheckedFba = this._detectChecked()
        // String() bắt buộc: barcode_number từ API là number, item_number là string
        const incompleteOrder = incompleteMap ? incompleteMap.get(String(item_number)) : null

        return (
            <tr className={classNames("RowBoxItem", location_type, {'incomplete-order': !!incompleteOrder})}>
                {showDelete &&
                    <td>
                        <Checkbox
                            checked={isCheckedFba}
                            onChange={() => this._handleChange(itemFba)}
                        />
                    </td>
                }
                <td>{index + 1}</td>
                <td>
                    {showDelete &&
                        <ButtonRemoveItem
                            onRefresh={onRefresh}
                            box={box}
                            item={itemFba}
                            onCheckAll={onCheckAll}
                        />
                    }
                    <strong>#{item_number}_{item_index}</strong>
                    {!!incompleteOrder &&
                        <Tag color="red" className="ml-1">thiếu {incompleteOrder.unpacked}</Tag>
                    }
                </td>
                <td>{type}</td>
                <td>{size}</td>
                <td>{getLocationType(location_type)}</td>
                <td>{partnerTrackingNumber || '--'}</td>
                <td>{timeHumanize(created)}</td>
                <td>{itemFba.shipment_status}</td>
            </tr>
        )
    }
}

RowBoxItem.propTypes = {
    index: PropTypes.number.isRequired,
    item: PropTypes.object.isRequired,
    box: PropTypes.object.isRequired,
    isPrivate: PropTypes.bool.isRequired,
    onRefresh: PropTypes.func.isRequired,
}


export default RowBoxItem
